import { DEFAULT_DATE_TIME_RANGE } from '@modules/common/components/DateRangePicker/constants';
import { SearchState } from './types';

export const searchInitialState: SearchState = {
  query: {
    duration: DEFAULT_DATE_TIME_RANGE,
    whereClause: null,
  },
  prompt: '',
  visual: {
    hasChangesToBeSaved: false,
    shouldHideTrackAsKeywordWidget: false,
    shouldShowQueryBuilder: false,
    areWidgetsLoading: {
      trackedKeywordsWidget: false,
      trendingReasonsWidget: false,
      sourceDistributionWidget: false,
    },
  },
};
